import { observer } from 'mobx-react-lite'
import React from 'react'
import { DatePickerDropdown, TimePicker } from 'shared/ui/DatePicker'
import { uiStore } from 'shared/store/uiStore'
import styles from './styles.module.scss'

type IDateEndTimeProps = {
  date: Date | null
  setDate: (value: Date | null) => void
  dropdownId: string
  defaultDate: Date
}

export const DateEndTime = observer((props: IDateEndTimeProps) => {
  const { date, setDate, dropdownId, defaultDate } = props
  return (
    <>
      <DatePickerDropdown
        selected={date}
        onChange={setDate}
        parentsDropdownId={[dropdownId]}
        excludeDateIntervals={[
          { start: new Date(0), end: uiStore.dayjs().add(-1, 'day').toDate() },
        ]}
        defaultValue={defaultDate}
        textFieldPlaceholderProps={{
          className: styles.wrapPicker,
          effect: 'collapse',
        }}
        triggerTooltipProps={{
          label: 'Date',
          placement: 'left',
          fullWidth: true,
        }}
      />
      <TimePicker
        selected={date}
        onChange={setDate}
        parentsDropdownId={[dropdownId]}
        textFieldPlaceholderProps={{
          className: styles.wrapPicker,
          variant: 'outline',
          effect: 'collapse',
        }}
        filteredPassedTime={uiStore.dayjs().toDate()}
        offsetMinutes={uiStore.offsetMinute}
        defaultValue={defaultDate}
        triggerTooltipProps={{
          label: 'Time',
          placement: 'left',
          fullWidth: true,
        }}
      />
    </>
  )
})
